<!--
 * @Author: wuhao
 * @Date: 2021-01-15 10:59:00
 * @LastEditors: wuhao
 * @LastEditTime: 2021-03-24 17:57:06
 * @Description: 封装el-button
-->
<template>
  <!--popConfirm形式-->
  <el-popconfirm
    v-if="confirmType === 'pop'"
    v-bind="popConfig"
    @onConfirm="confirm"
    @onCancel="$emit('cancel')"
  >
    <el-button
      slot="reference"
      v-loading.fullscreen.lock="fullscreenLoadingStatus"
      v-bind="$attrs"
      :type="type"
    >
      <slot />
    </el-button>
  </el-popconfirm>
  <el-button
    v-else
    v-loading.fullscreen.lock="fullscreenLoadingStatus"
    element-loading-text="Loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)"
    v-bind="$attrs"
    :loading="loadingStatus"
    :type="type"
    @click="handleClick"
  >
    <slot />
  </el-button>
</template>

<script>
import { t } from '@/locale'
import locale from '@/mixins/index'
import _throttle from 'lodash.throttle'

export default {
  name: 'ApexButton',
  mixins: [locale],
  inheritAttrs: false,
  props: {
    throttle: {
      type: Boolean,
      default: false
    },
    autoLoading: {
      type: Boolean,
      default: false
    },
    autoFullscreenLoading: {
      type: Boolean,
      default: false
    },
    confirmType: {
      type: String,
      default: ''
    },
    popConfig: {
      type: Object,
      default: () => ({
        title: t('common.deleteTip'),
        'confirm-button-text': t('common.confirm'),
        'cancel-button-text': t('common.cancel')
      })
    },
    type: {
      type: String,
      default: ''
    },
    confirmConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loadingStatus: false,
      fullscreenLoadingStatus: false
    }
  },
  methods: {
    handleClick() {
      if (this.confirmType && this.confirmType === 'confirm') {
        this.messageConfirm()
        return
      }
      if (!this.throttle) {
        if (this.autoLoading) {
          this.loadingStatus = true
        }
        if (this.autoFullscreenLoading) {
          this.fullscreenLoadingStatus = true
        }
        this.$emit('click', () => {
          this.loadingStatus = false
          this.fullscreenLoadingStatus = false
        })
        return
      }
      this.throttleClick()
    },
    messageConfirm() {
      const {
        message = this.t('common.deleteTip'),
        title = this.t('common.title'),
        confirmButtonText = this.t('common.confirm'),
        cancelButtonText = this.t('common.cancel'),
        type = 'warning'
      } = this.confirmConfig
      this.$confirm(message, title, {
        confirmButtonText,
        cancelButtonText,
        type
      })
        .then(() => {
          this.confirm()
        })
        .catch(() => {
          this.$emit('cancel')
        })
    },
    confirm() {
      if (this.autoFullscreenLoading) {
        this.fullscreenLoadingStatus = true
      }
      this.$emit('confirm', () => {
        this.fullscreenLoadingStatus = false
      })
    },
    throttleClick: _throttle(function() {
      this.$emit('click')
    }, 500, { trailing: false })
  }
}
</script>
